import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

import { Observable, of } from 'rxjs';
import { catchError, map, tap, timeout } from 'rxjs/operators';

import { ApiService } from './api.service';
import { StorageService } from './storage.service';

import { DeliveryFeeTable, Company } from '../models';

import { Utils } from '../helpers/utils';

@Injectable({ providedIn: 'root' })
export class DeliveryService {
  current: DeliveryFeeTable;
  selectedDistrictObj: {bairro: string, valor: string};
  company: Company;

  constructor(private api: ApiService,
    private storage: StorageService) {
  }

  getCurrent(): Observable<any> {
    this.company = this.company || this.storage.getInLocal('current_company');

    let self = this;
    let cur = self.storage.getInSession('current_delivery_fee_table_' + this.company.name);
    if(cur == null){
      return self._fetchCurrent();
    } else {
      return new Observable((obs) => {
        self.current = cur;
        obs.next(self.current);
        obs.complete();
      });
    }
  }
  selectDistrict(district: string) {
    let value = this.queryValue(district);
    this.storage.storeInLocal('selected_district', {bairro: district, valor: value.toFixed(2)});
  }
  selectDistrictObj(districtObj: {bairro: string, valor: string}) {
    this.storage.storeInLocal('selected_district', districtObj);
  }
  clearSelectedDistrict() {
    this.selectedDistrictObj = null;
    this.storage.removeInLocal('selected_district');
  }
  getSelectedDistrictObj(fetchNewValue: boolean = true): {bairro: string, valor: string} {
    this.selectedDistrictObj = this.storage.getInLocal('selected_district');
    if(this.selectedDistrictObj && this.current && fetchNewValue) {
      this.selectedDistrictObj.valor = this.queryValue(this.selectedDistrictObj.bairro).toString();
    }
    return this.selectedDistrictObj;
  }

  queryValue(district: string): number {
    if(!this.current)
      return null;

    console.log(district);

    if(district == "<localização>") {
      return Number(this.getSelectedDistrictObj(false).valor);
    }

    let found: {bairro: string, valor: string} = Utils.findById(district, this.current.tableObj, 'bairro');

    if(!found) {
      console.error(`DeliveryService: não foi encontrado o bairro ${district} na tabela`, this.current.tableObj);
      return null;
    }

    return Number(found.valor);
  }

  getBeeDeliveryTableObject(delivery_fee_table: DeliveryFeeTable): {bairro: string, valor: string}[] {
    let parsedTable = JSON.parse(delivery_fee_table.table);
    let result: {bairro: string, valor: string}[] = [];
    for(let key in parsedTable) {
      let bairro_valor = unescape(decodeURIComponent(parsedTable[key]));
      let bairro_valor_separado = bairro_valor.split(' - R$ ');
      let valor = Number(bairro_valor_separado[1]);

      let modifier = delivery_fee_table.modifier;
      if(!!modifier) {
        modifier = modifier.toString().replace(',','.');
        if(modifier.indexOf('%') != -1) { // is percentage
          valor *= 1 + (Number(modifier.split('%')[0]) / 100);
        } else { // is raw value
          valor += Number(modifier);
        }
      }

      result.push({
        bairro: bairro_valor_separado[0],
        valor: valor.toFixed(2)
      });
    }
    return result;
  }

  private _fetchCurrent(): Observable<any> {
    let self = this;
    return new Observable((obs) => {
      self.api.show('delivery_fee_tables', 'current', {
        q: {
          company_id: this.company.id
        }
      }).subscribe(
        res => {
          if(JSON.stringify(res.delivery_fee_table) == "[]") { // there is no delivery_fee_table
            self.current = null;
            obs.next(null);
            return;
          }
          
          self.current = res.delivery_fee_table;
          self.current.tableObj = self.getBeeDeliveryTableObject(self.current);
          // expire after five minutes
          self.storage.storeInSession('current_delivery_fee_table_' + this.company.name, self.current, 60*5);
          obs.next(self.current);
        },
        err => {
          alert("Não foi possível obter as taxas de entrega");
          obs.error(err);
        },
        () => {
          obs.complete();
        }
      );
    });
  }
}